import type { JSX } from "react";
import { formatDateSeparator } from "../../utils/time";
import { cn } from "./cn";

export interface DateSeparatorProps {
  readonly date: Date;
  readonly className?: string;
}

export function DateSeparator({ date, className }: DateSeparatorProps): JSX.Element {
  const { label, isToday } = formatDateSeparator(date);

  return (
    <div className={cn("flex items-center gap-3 py-3 px-4", className)}>
      <div className="flex-1 border-t border-edge" />
      <span
        className={cn(
          "text-xs font-medium uppercase whitespace-nowrap",
          isToday ? "text-orange-500" : "text-content-secondary",
        )}
      >
        {label}
      </span>
      <div className="flex-1 border-t border-edge" />
    </div>
  );
}
